import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';
import { IPartInventoryItem } from 'parts/types';

interface IProps extends ICellRendererParams<IPartInventoryItem> {
  isAlternateVersionEnabled?: boolean;
}

export const LocationCell = ({ data, value, isAlternateVersionEnabled }: IProps) => {
  if (!data) {
    return value;
  }

  return (
    <Stack>
      <TextLine text={data.locationName || DEFAULT_PLACEHOLDER} />
      {isAlternateVersionEnabled && (
        <TextLine text={data.externalLocationId || DEFAULT_PLACEHOLDER} isSubText />
      )}
    </Stack>
  );
};
